// ZynexTech Clerk Configuration
// Update this key with your actual Clerk publishable key from your Clerk Dashboard
// Should look like: pk_test_xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
export const ZYNEXTECH_CLERK_PUBLISHABLE_KEY = "pk_live_Y2xlcmsuenluZXh0ZWNoYWkuY29tJA";

// IMPORTANT SECURITY NOTES:
// ✅ ONLY use the PUBLISHABLE key here (safe for client-side)
// ❌ NEVER put your SECRET key here (server-side only)
// 
// Note: This key is hardcoded to ensure all authentication goes through ZynexTech's Clerk organization
// Customers cannot override this key, ensuring centralized user management and billing control 